import { useEffect, useState } from 'react';

/**
 * Aviso de operação em andamento, com relógio.
 *
 * Existe por causa da emissão de documento, que leva alguns segundos. Sem aviso, a tela
 * parece travada — e a reação natural é clicar de novo, justamente o que não pode
 * acontecer numa esteira que emite documento e cobra dinheiro.
 *
 * O relógio não é enfeite: ver o número subir é o que distingue "está trabalhando" de
 * "morreu". Já o texto fica no essencial: por que está lento é problema nosso, não de quem
 * está com um candidato na linha esperando o documento.
 */
export interface EtapaDaEspera {
  /** A partir de quantos segundos esta mensagem passa a valer. */
  apos: number;
  texto: string;
}

interface Props {
  titulo: string;
  descricao: string;
  etapas?: EtapaDaEspera[];
}

export function Aguarde({ titulo, descricao, etapas = [] }: Props) {
  const [segundos, setSegundos] = useState(0);

  useEffect(() => {
    const relogio = setInterval(() => setSegundos((s) => s + 1), 1000);
    return () => clearInterval(relogio);
  }, []);

  const etapaAtual = [...etapas]
    .sort((a, b) => a.apos - b.apos)
    .filter((e) => segundos >= e.apos)
    .at(-1);

  return (
    <div className="fundo-modal" role="status" aria-live="polite" aria-busy="true">
      <div className="modal modal-espera">
        <div className="girando" aria-hidden="true" />
        <h3>{titulo}</h3>
        <p className="modal-corpo">{etapaAtual?.texto ?? descricao}</p>
        <div className="relogio-espera">
          {segundos}
          <span>s</span>
        </div>
      </div>
    </div>
  );
}
